import axiosService from "services/axios.service";

const API_URL = process.env.REACT_APP_URL_API;

const BASE_API_URL = `${API_URL}/v1/admin`;

export const accessUserToLabel = async (payload: any): Promise<any> => {
  const response = await axiosService.post(
    `${BASE_API_URL}/labels-access/to/user`,
    payload
  );

  return response?.data?.data;
};

export const getLabelAccessWIthUserId = async (
  userId: string
): Promise<any> => {
  const response = await axiosService.get(
    `${BASE_API_URL}/labels-access/user/${userId}`
  );

  return response?.data?.data;
};

export const getLabelWithUserId = async (userId: string): Promise<any> => {
  const response = await axiosService.post(`${BASE_API_URL}/labels/list`, {
    userId,
  });

  return response?.data?.data;
};
